// extracted by mini-css-extract-plugin
module.exports = {"search-panel":"SearchPanel_search-panel__2LSNV"};